import { render, staticRenderFns } from "./manage-tags.vue?vue&type=template&id=0f321c28&"
import script from "./manage-tags.vue?vue&type=script&lang=js&"
export * from "./manage-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports